// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1ADde","rotate":"Loader_rotate__bUL-R"};